import React, { useRef } from "react";
import { ArrowIcon, ModalClosed } from "~misc/icons";
import "./index.scss";
import ensacados from "../../assets/images/ensacados.png";
import useClientes from "~/fetchs/useClientes";
import { useNavigate, Link } from "react-router-dom";

const ModalSimulators = ({ isOpen, onClose, clienteCodigo, clienteId }) => {
  const navigate = useNavigate();
  const modalClasses = isOpen ? "fixed inset-0 bg-black bg-opacity-0 z-[99999]" : "hidden";
  const overlayClasses = isOpen ? "fixed inset-0 bg-black opacity-5  z-40" : "hidden";

  return (
        <div className={modalClasses}>
          <div className="fixed inset-0 flex items-center justify-center z-50">
            <div className="bg-white min-w-[680px] px-14 py-14 rounded-[20px] shadow-lg z-50  relative">
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={onClose}
                  className="text-gray-500 p-4 rounded-tr-[20px] hover:text-gray-700 bg-quinaria absolute top-0 right-0"
                >
                  <ModalClosed />
                </button>
              </div>
              <h2 className="mx-auto field__label text-[1.2rem] font-bold block mt-6 mb-2">Selecione o Simulador </h2>
              <div className="flex flex-col gap-y-4">
                <Link 
                    onClick={async (e) => {
                        navigate(`/simuladores/${clienteId}/simulacao-nova`)
                    }}
                    className="flex items-center gap-x-4 justify-between"
                >
                    <div className="flex items-center gap-x-4">
                        <div className="bg-primaria rounded-full max-w-[90px] flex justify-center p-6">
                            <img src={ensacados} alt="" />
                        </div>
                        <h3 className="font-bold text-[1.2rem] uppercase">Ensacados</h3>
                    </div>
                    <button
                        type="button"
                        style={{
                            transform: "rotate(-180deg)",
                        }}
                        >
                        <ArrowIcon />
                    </button>
                </Link>
                <Link 
                    to={`https://comercial-qa.vcimentos.com/#/imo/${clienteCodigo}`}
                    target="_blank"
                    className="flex items-center gap-x-4 justify-between"
                >
                    <div className="flex items-center gap-x-4">
                        <div className="bg-primaria rounded-full max-w-[90px] flex justify-center p-6">
                            <img src={ensacados} alt="" />
                        </div>
                        <h3 className="font-bold text-[1.2rem] uppercase">Concreto</h3>
                    </div>
                    <button
                        type="button"
                        style={{
                            transform: "rotate(-180deg)",
                        }}
                        >
                        <ArrowIcon />
                    </button>
                </Link>
              </div>
            </div>
            <div className={overlayClasses} onClick={onClose}></div>
          </div>
        </div>  
  );
};

export default ModalSimulators;
